import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const ParameterEnabledButton = ({effect, i, parametersDisabled}) => { 
    let isDisabled = parametersDisabled.includes(i);
    let className = "param-enabled-btn ";
    if (isDisabled) {
        className += " disabled";
    }

    const toggle = useCallback(() => {
        let _parametersDisabled;
        if (isDisabled) {
            _parametersDisabled = parametersDisabled.filter(
                p => p !== i);
        } else {
            _parametersDisabled = [... parametersDisabled, i];
        }
        effect.parametersDisabledParameter.set(
            _parametersDisabled, false);
    }, [parametersDisabled, isDisabled, effect, i]);

    return (
        <div onClick={toggle} className={className}/>);
};

const mapStateToProps = (state, props) => {
  return {
      parametersDisabled: props.effect.parametersDisabled
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ParameterEnabledButton);
